import { MEDIA_QUERIES } from 'javascripts/constants';
import Slider from '../../../javascripts/globals/slider';

export default class TeaserSlider extends Slider {
  constructor($teaserSlider, mq, config) {
    super($teaserSlider, mq, config);
    this.$slider = $teaserSlider;
    this.hasFiveSlides = this.$slider?.classList.contains(
      'teaser-slider--five'
    );
    this.hasOneSlide = this.$slider?.classList.contains('teaser-slider--one');
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();

    if (this.itemsToScroll < this.numberOfSlides) {
      this.$slider.classList.remove('teaser-slider--no-controls');
      this.initControls();
      super.initEvents();
    } else {
      this.$slider.classList.add('teaser-slider--no-controls');
    }
  }

  handleResize() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    super.handleResize();
  }

  initControls() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    super.initControls();
  }

  updateArrows() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    super.updateArrows();
  }

  updateDots() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    super.updateDots();
  }

  renderDots() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    super.renderDots();
  }

  nextSlide() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    super.nextSlide();
  }

  prevSlide() {
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    super.prevSlide();
  }

  getItemsVisible() {
    if (this.hasOneSlide) {
      return 1;
    }

    this.hasFiveSlides = this.$slider?.classList.contains(
      'teaser-slider--five'
    );

    const mqXl = window.matchMedia(MEDIA_QUERIES.xl);
    const mqM = window.matchMedia(MEDIA_QUERIES.m);

    // mobile
    let itemsVisible = 1;

    if (this.hasFiveSlides) {
      itemsVisible = 2;
    }

    // tablet
    if (mqM.matches) {
      itemsVisible = 2;

      if (this.hasFiveSlides) {
        itemsVisible = 3;
      }
    }

    // tablet landscape or small desktop
    if (mqXl.matches) {
      itemsVisible = 3;

      if (this.hasFiveSlides) {
        itemsVisible = 5;
      }
    }

    return itemsVisible;
  }

  getItemsToScroll() {
    if (this.hasOneSlide) {
      return 1;
    }

    this.hasFiveSlides = this.$slider?.classList.contains(
      'teaser-slider--five'
    );

    const mqXl = window.matchMedia(MEDIA_QUERIES.xxl);
    const mqM = window.matchMedia(MEDIA_QUERIES.m);

    // mobile
    let itemsToScroll = 1;

    if (this.hasFiveSlides) {
      itemsToScroll = 2;
    }

    // tablet
    if (mqM.matches) {
      itemsToScroll = 2;

      if (this.hasFiveSlides) {
        itemsToScroll = 3;
      }
    }

    // tablet landscape or small desktop
    if (mqXl.matches) {
      itemsToScroll = 3;

      if (this.hasFiveSlides) {
        itemsToScroll = 5;
      }
    }

    return itemsToScroll;
  }
}
